import { AfterViewInit, Component, ElementRef, EventEmitter, Inject, OnInit, Output, ViewChild } from '@angular/core';
import c3 from 'c3';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
const monthnames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

@Component({
  selector: 'app-da-chart-popup',
  templateUrl: './da-chart-popup.component.html',
  styleUrls: ['./da-chart-popup.component.scss']
})
export class DaChartPopupComponent implements OnInit, AfterViewInit {

  @ViewChild('lineGraphDiv') lineGraphDiv: ElementRef;
  @ViewChild('barGraphDiv') barGraphDiv: ElementRef;
  @Output() factorySummary = new EventEmitter<any>();
  @Output() currentDate = new EventEmitter<any>();
  @Output() currrentFilter = new EventEmitter<any>();
  public oneDate: any;
  public monthName: any;
  currentEndWeek: any;
  emitDataList: any;


  chart: any;
  public selectedChartType = 'cost'; // percentage
  currentlevel: string;
  constructor(public dialogRef: MatDialogRef<DaChartPopupComponent>, @Inject(MAT_DIALOG_DATA) public data) { }

  ngOnInit() {
    this.currentlevel = this.data.level;
    const daDate = this.getLocalStorageData('selectedDATimeFilter');
    this.currentEndWeek = '';
    // const startOfMonth = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
    // const endOfMonth = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
    this.emitDataList = {
      appliedFilterType: daDate ? daDate.appliedFilterType : '',
      dateObj: new Date(daDate.endOfMonth),
      selectedHr: daDate.selectedHr,
      endWeekFromSelectedDate: daDate.endWeekFromSelectedDate,
      startQuarterMonth: null
    };
    this.oneDate = this.emitDataList.dateObj;
    this.monthName = this.oneDate.toLocaleString('en-us', { month: 'short' });
    try {
      this.selectedChartType = this.data.type;
    } catch (error) {

    }
  }

  getLocalStorageData(key: string) {
    return JSON.parse(sessionStorage.getItem(key));
  }

  ngAfterViewInit(): void {

    setTimeout(() => {
      this.drawLineGraph();
      this.drawBarGraph();
    }, 0);
  }


  drawLineGraph() {
    try {
      const chart = c3.generate({
        bindto: this.lineGraphDiv.nativeElement,
        size: {
          height: 360,
          width: 700
        },
        data: {
          x: 'x',
          columns: [
            this.data.xAxisValuesPercentage,
            this.data.targetBasedList,
            this.data.lineWastePercentage
          ],
          axes: {
            waste: 'y2'
          },
          colors: {
            data1: '#D26999',
            data2: '#82C7C2'
          },
          names: {
            data1: 'Waste %',
            data2: 'Target Waste %'
          }
        },
        point: {
          show: false
        },
        axis: {
          x: {
            label: {
              text: ((this.emitDataList &&
                (this.emitDataList.appliedFilterType === 'quarter' || this.emitDataList.appliedFilterType === 'year'))
                ? 'Month' : 'Date'),
              position: 'outer-center'
            },
            show: true
          },
          y: {
            show: true,
            label: {
              text: 'Waste %',
              position: 'outer-middle'
            },
            tick: {
              format: ((y) => y + '%'),
              outer: true,
            }
          },
          y2: {
            show: true,
            tick: {
              format: ((y) => y + '%'),
              values: [],
              outer: true,
            }
          }
        },
        tooltip: {
          format: {
            title: (x: number) => (this.emitDataList &&
              (this.emitDataList.appliedFilterType === 'quarter' || this.emitDataList.appliedFilterType === 'year')
              ? monthnames[x - 1] : (x + ' ' + this.monthName + ' ')),
            value: (x: number) => x.toFixed(2) + '%'
          }
        },
      });
    } catch (error) {

    }
  }

  drawBarGraph() {
    const thisObj = this;
    const chart = c3.generate({
      bindto: this.barGraphDiv.nativeElement,
      size: {
        height: 360,
        width: 700
      },
      data: {
        x: 'x',
        columns: [
          this.data.xAxisValuesCost,
          this.data.actualConsList,
          this.data.zeroBasedList,
          this.data.targetWasteCost
        ],
        types: {
          data1: 'bar',
          data2: 'bar',
          waste: 'line'
        },
        colors: {
          data1: '#00A9E0',
          data2: '#1B4972',
          waste: '#D26999'
        },
        names: {
          data1: 'Actual Consumption',
          data2: 'Zero Based Waste Target',
          waste: 'Target Waste Cost'
        }
      },
      point: {
        show: false
      },
      axis: {
        x: {
          label: {
            text: ((this.emitDataList &&
              (this.emitDataList.appliedFilterType === 'quarter' || this.emitDataList.appliedFilterType === 'year'))
              ? 'Month' : 'Date'),
            position: 'outer-center'
          },
        },
        y: {
          label: {
            text: 'Cost',
            position: 'outer-middle'
          },
          tick: {
            format: ((x) => (x / thisObj.data.divisionNumber) + thisObj.data.signType)
          },
        },
        y2: {
          show: true,
          tick: {
            values: []
          }
        }
      },
      tooltip: {
        format: {
          title: (x: number) => (this.emitDataList &&
            (this.emitDataList.appliedFilterType === 'quarter' || this.emitDataList.appliedFilterType === 'year')
            ? monthnames[x - 1] : (x + ' ' + this.monthName + ' ')),
          value: (x: number) => (x / thisObj.data.divisionNumber).toFixed(2) + thisObj.data.signType
        }
      },
      bar: {
        width: 4
      }
    });
  }

  toggleType(type: string) {
    try {
      if (type !== this.selectedChartType) {
        this.selectedChartType = type;
        this.drawLineGraph();
        this.drawBarGraph();
      }
    } catch (error) {

    }
  }

  closeDialog() {
    try {
      this.dialogRef.close();
    } catch (error) {

    }
  }

}
